'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import UIFormControl from 'UIComponents/form/UIFormControl';
export default function InputWrapper(props) {
  return /*#__PURE__*/_jsx(ToolFieldset, {
    children: /*#__PURE__*/_jsx(UIFormControl, {
      label: props.label,
      description: props.description,
      help: props.help,
      children: props.children
    })
  });
}
InputWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
  help: PropTypes.node
};